import { signOutUseCase } from "../../usecases/user";

class ContactUsPagePresenter {
  constructor(view, signOutUseCase) {
    this.view = view;
    this.signOutUseCase = signOutUseCase;
  }

  onClickSignOut() {
    const options = {
      title: "Confirm",
      message: "Are you sure you want to sign out?",
      positiveButton: "SIGN OUT",
    };

    this.view
      .showDialog(options)
      .then(() => this.signOutUseCase.execute())
      .then(() => {
        localStorage.removeItem("selectedJobs");
        localStorage.removeItem("user");
        this.view.navigateTo("/signin");
      })
      .catch((error) => {
        this.view.showError(error);
      });
  }
}

export default ContactUsPagePresenter;
